import { IStore } from '../types/IStore';

export const getLatestError = (state: IStore) => state.error.latestError;
export const getErrorType = (state: IStore) => state.error.errorType;
